import { useContext, useState, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import Icon_Color_Success from "../../Assets/Icons/Icon_Color_Success.png";
import Icon_Color_Error from "../../Assets/Icons/Icon_Color_Error.png";

export default function UI_UpdatingStatus({
    id,
    State,
    Good,
    Bad,
    Loading
}) {
    const UI = useContext(Context_UI);

    return (
        <>
            <div className="UpdatingStatus" State={State}>
                {State == "Good" ?
                    <>
                        {
                            Good.Type == "Default" ?
                                <div className="UpdatingStatus_Default">
                                    {Good.Icon == "Default" ?
                                        <img src={Icon_Color_Success} className="UpdatingStatus_Default_Icon" />
                                        :
                                        <img src={Good.Icon} className="UpdatingStatus_Default_Icon" />
                                    }
                                    <h2 className="UpdatingStatus_Title">
                                        {Good.Title}
                                    </h2>
                                    <p className="UpdatingStatus_Text">
                                        {Good.Text}
                                    </p>
                                </div>
                                :
                                <div className="UpdatingStatus_Content">
                                    {Good.Content}
                                </div>

                        }
                    </>
                    :
                    State == "Bad" ?
                        <>
                            {
                                Bad.Type == "Default" ?
                                    <div className="UpdatingStatus_Default">
                                        {Bad.Icon == "Default" ?
                                            <img src={Icon_Color_Error} className="UpdatingStatus_Default_Icon" />
                                            :
                                            <img src={Bad.Icon} className="UpdatingStatus_Default_Icon" />
                                        }
                                        <h2 className="UpdatingStatus_Title">
                                            {Bad.Title}
                                        </h2>
                                        <p className="UpdatingStatus_Text">
                                            {Bad.Text}
                                        </p>
                                    </div>
                                    :
                                    <div className="UpdatingStatus_Content">
                                        {Bad.Content}
                                    </div>

                            }
                        </>
                        :
                        State == "Loading" ?
                            <>
                                {
                                    Loading.Type == "Default" ? 
                                        <div className="UpdatingStatus_Default" State="Loading">
                                            <div className="Loader_Square">
                                                <div className="Loader_Square_Component"></div>
                                                <div className="Loader_Square_Component"></div>
                                                <div className="Loader_Square_Component"></div>
                                                <div className="Loader_Square_Component"></div>
                                            </div>
                                            <h2 className="UpdatingStatus_Title">
                                                {Loading.Title}
                                            </h2>
                                            <p className="UpdatingStatus_Text">
                                                {Loading.Text}
                                            </p>
                                        </div>
                                        :
                                        <div className="UpdatingStatus_Content">
                                            {Loading.Content}
                                        </div>
                                }
                            </>
                            :
                            ""
                }
            </div>
        </>
    );
}
